export default "__VITE_ASSET__xxUUhHxH__"